
import axios from "axios";

export function fetchShip(shipName) {
    const url = `http://api.shipxy.com/apicall/QueryShip?v=2&k=35fdad32ae4e4a33837ba85d9cb2fb64&enc=1&kw=${shipName}&max=3`;
    const request = axios.get(url);
    return request;
}